import { Box, Flex, Text } from '@chakra-ui/react'
import { useAudioCapture, useExperienceManager } from '@hooks'
import { times } from 'lodash'
import React from 'react'

export const AudioLevelV2 = ({
  label,
  audioLevel
}: {
  label?: string
  audioLevel: number
}) => {
  const { isWidget, isExtension } = useExperienceManager()
  const { isMuted } = useAudioCapture()
  const numBars = isWidget ? 10 : 15
  const bgColor = isExtension ? '#FFF' : '#CBCCCD'

  return (
    <Box mt="16px !important" data-testid="audio-level-v2">
      <Flex justifyContent="center">
        {times(numBars, i => (
          <Box
            key={i}
            h="16px"
            w="6px"
            borderRadius="4px"
            bg={
              audioLevel >= (i + 1) * (1 / numBars) && !isMuted
                ? '#68E19F'
                : bgColor
            }
            border={isExtension ? '' : '1px solid #C3C3C9'}
            mr="6px"
          />
        ))}
      </Flex>
      {label && (
        <Text
          fontSize="16px"
          color={isExtension ? '#FFF' : '#757575'}
          textAlign="center"
          data-testid="audio-level-label"
          mt="16px"
        >
          {label}
        </Text>
      )}
    </Box>
  )
}
